/* tslint:disable */
/* eslint-disable */
/**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    EvmToken,
    EvmTokenFromJSON,
    EvmTokenFromJSONTyped,
    EvmTokenToJSON,
    EvmTokenListAllOf,
    EvmTokenListAllOfFromJSON,
    EvmTokenListAllOfFromJSONTyped,
    EvmTokenListAllOfToJSON,
    List,
    ListFromJSON,
    ListFromJSONTyped,
    ListToJSON,
} from './';

/**
 * 
 * @export
 * @interface EvmTokenList
 */
export interface EvmTokenList {
    /**
     * The total number of records that match the query, i.e. the number of records
     * the query would return with limit=infinity.
     * @type {number}
     * @memberof EvmTokenList
     */
    total_count: number;
    /**
     * Whether total_count is clipped for performance reasons.
     * @type {boolean}
     * @memberof EvmTokenList
     */
    is_total_count_clipped: boolean;
    /**
     * A list of L2 EVM tokens (ERC-20, ERC-721, ...).
     * @type {Array<EvmToken>}
     * @memberof EvmTokenList
     */
    evm_tokens: Array<EvmToken>;
}

export function EvmTokenListFromJSON(json: any): EvmTokenList {
    return EvmTokenListFromJSONTyped(json, false);
}

export function EvmTokenListFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvmTokenList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total_count': json['total_count'],
        'is_total_count_clipped': json['is_total_count_clipped'],
        'evm_tokens': ((json['evm_tokens'] as Array<any>).map(EvmTokenFromJSON)),
    };
}

export function EvmTokenListToJSON(value?: EvmTokenList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.total_count,
        'is_total_count_clipped': value.is_total_count_clipped,
        'evm_tokens': ((value.evm_tokens as Array<any>).map(EvmTokenToJSON)),
    };
}


